export default "__VITE_ASSET__DdbFf6mG__"